// <head> metadata for PrivacyPage (https://www.dbos.dev/privacy).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Privacy Policy | DBOS',
    },
    {
      name: 'description',
      content:
        'How DBOS, Inc. collects, uses and discloses personal information when you visit our websites or otherwise interact with us.',
    },
    {
      property: 'og:title',
      content: 'Privacy Policy | DBOS',
    },
    {
      property: 'og:description',
      content:
        'How DBOS, Inc. collects, uses and discloses personal information when you visit our websites or otherwise interact with us.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Privacy Policy | DBOS',
    },
    {
      name: 'twitter:description',
      content:
        'How DBOS, Inc. collects, uses and discloses personal information when you visit our websites or otherwise interact with us.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/privacy',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
